// @flow

import React, { useEffect } from "react";
import { localize } from "redux-i18n";
import {
  Modal as BsModal,
  ModalHeader as BsModalHeader,
  ModalBody as BsModalBody,
  ModalFooter as BsModalFooter,
} from "reactstrap";
import { withFocusFirstInput, View, Button } from "@components";

type Props = {
  width?: string,
  className?: string,
  rightPanel?: boolean,
  title?: string,
  onToggle?: Function,
  children: React$Node,
  isSubmitBtnDisabled?: boolean,
  onSubmit?: Function,
  ...PropsFromLocalize,
};
function Modal({
  width,
  className,
  rightPanel,
  onToggle,
  children,
  title,
  onSubmit,
  isSubmitBtnDisabled,
  t,
}: Props) {
  const isRightPanel = rightPanel;
  useEffect(() => {
    const backdrop = document.querySelector(".modal-backdrop");
    document.addEventListener("keydown", onClose, true);
    backdrop && backdrop.addEventListener("click", onBackdropClick, true);

    return () => {
      document.removeEventListener("keydown", onClose, true);
      backdrop && backdrop.removeEventListener("click", onBackdropClick, true);
    };
  }, []);
  useEffect(() => {
    // $FlowIgnore
    document.documentElement.style.setProperty("--side-panel-width", width || "50vw");
  }, [width]);

  function onBackdropClick(e: MouseEvent) {
    e.isTrusted && onToggle && onToggle();
  }

  function onClose(e: KeyboardEvent) {
    if (e.keyCode === 27 || e.type == "click") {
      // 27 = Esc key
      const footers = document.querySelectorAll(".modal .modal-footer");
      const modalFooter = footers[footers.length - 1];
      if (modalFooter) {
        const btnSecondary = modalFooter.querySelector("button.secondary");

        if (btnSecondary) {
          return btnSecondary.click();
        } else {
          const btn = modalFooter.querySelector("button");
          if (btn) return btn.click();
        }
      } else {
        console.error("No modal footer detected, plase add footer");
      }
    }
  }

  if (isRightPanel) className = "right-panel";
  else if (!className || className == "") className = "modal-medium";

  return (
    <BsModal
      isOpen={true}
      fade={!isRightPanel}
      backdropClassName={`${(isRightPanel && "backdrop-right-panel") || ""}`}
      className={`modal-wrapper ${className} `}
    >
      {title && (
        <View flex={1} padding={[0, 6, 6, 6]} gap={3}>
          <View
            direction="row"
            separator="bottom"
            padding={[3, 0, 3, 0]}
            backgroundColor={"white"}
            position="sticky"
            zIndex={5}
            top={0}
            justifyContent="space-between"
          >
            <View flex={1}>
              <h3>{title}</h3>
            </View>
            <View gap={3} direction="row">
              <Button onClick={onToggle} color="secondary" label={t("CANCEL")} />

              <Button
                onClick={onSubmit}
                disabled={isSubmitBtnDisabled}
                color="primary"
                materialIcon="replay_circle_filled"
                label={t("SUBMIT")}
              />
            </View>
          </View>
          {children}
        </View>
      )}
      {!title && children}
    </BsModal>
  );
}
export default localize()(Modal);

export const ModalHeader = (props: Object) => (
  <BsModalHeader
    {...props}
    className={`d-flex justify-content-between align-items-center font-weight-bold ${props.className ||
      ""}`}
  >
    {props.children}
  </BsModalHeader>
);

ModalHeader.propTypes = BsModalHeader.propTypes;
ModalHeader.defaultProps = {
  tag: "h4",
};

const ModalB = props => (
  <BsModalBody {...props} className={`${props.className || ""}`}>
    {props.children}
  </BsModalBody>
);

ModalB.propTypes = BsModalBody.propTypes;

export const ModalBody = withFocusFirstInput(ModalB, "div.modal-dialog");

export const ModalFooter = (props: Object) => (
  <BsModalFooter
    {...props}
    className={`d-flex justify-content-end align-items-center bg-light-grey rounded-bottom ${props.className}`}
  >
    {props.children}
  </BsModalFooter>
);

ModalFooter.propTypes = BsModalFooter.propTypes;
